import { render, staticRenderFns } from "./mode-switcher.vue?vue&type=template&id=14770095&"
import script from "./mode-switcher.vue?vue&type=script&lang=js&"
export * from "./mode-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports